<div class="bg-gray-50 min-h-screen">
  <div class="container mx-auto px-4 py-8">
    <div class="flex justify-end mb-4">
      <button type="button"
              data-testid="clear-all-filters"
              (click)="clearAllFilters()"
              class="px-3 py-1.5 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-100 transition-colors">
        {{ 'clear' | translate }} {{ 'filters' | translate }}
      </button>
    </div>

    <app-client-list (itemSelected)="onClientSelected($event)"></app-client-list>

    @if (selectedClient()) {
      <app-point-of-service-list [isNested]="true" [nestedData]="pointOfServices()" (itemSelected)="onPointOfServiceSelected($event)"></app-point-of-service-list>

      @if (truckerActivities()) {
        <app-trucker-activity-list [isNested]="true" [nestedData]="truckerActivities()" [fkPointOfServiceId]="selectedPointOfService()?.id ?? null"></app-trucker-activity-list>
      }

      <div class="flex justify-between mt-8">
        @if (truckers()) {
          <app-trucker-list [isNested]="true" [nestedData]="truckers()" [fkPointOfServiceId]="selectedPointOfService()?.id ?? null" class="w-[45%] ml-12"></app-trucker-list>
        }
        @if (docks()) {
          <app-dock-list [isNested]="true" [nestedData]="docks()" [fkPointOfServiceId]="selectedPointOfService()?.id ?? null" class="w-[45%] relative -left-[50px]"></app-dock-list>
        }
      </div>
    }
  </div>
</div>
